<template>
    <div>
        <div id="overlay" v-if="fetchingData">
            <div class="spinner"></div>
        </div>
        <h1>
            Thank you!
        </h1>
        <p>
            Your Site Equipment Change request has been submitted. You will be notified when this change request
            has been processed.
        </p>
        <p>
            Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
            system. After approval of your permit application by the department, it will be emailed to the address you
            provided with your application.
        </p>
        <dl class="row">
            <dt class="col-12">For Customer Service:</dt>
            <dt class="col-sm-3">Hours:</dt>
            <dd class="col-sm-9">8:30am - 4:30pm</dd>
            <dt class="col-sm-12">Email: certificateofoperations@cookcountyil.gov</dt>
        </dl>
    </div>
</template>
<script>
import { submitEquipmentChangeRequest, getChangeFees, confirmTransaction } from '@/js/FormFunctions';

export default {
  name: 'AirThankYouNoFee',
  data() {
    return {
      siteNumber: '',
      fetchingData: false,
      erroMessage: '',
    };
  },
};

</script>
